import * as React from 'react'
import { timestampToDateTimeString } from 'src/share/utils/utils';
import { Row } from 'reactstrap';
import { IAlertInfo } from 'src/modules/Alert/Create/types';

export interface IAppState {
  date?: string
  processed?: boolean;
}

export interface IAppProps {
  alertInfo: IAlertInfo;
}

export class AlertStatus extends React.PureComponent<IAppProps, IAppState> {
  constructor(props: IAppProps) {
    super(props);
    this.state = {}
  }
  public static getDerivedStateFromProps(nextProps: IAppProps, prevState: IAppState) {
    const { processedDate, processed } = nextProps.alertInfo
    return {
      date: processedDate ? timestampToDateTimeString(processedDate) : processedDate,
      processed
    }
  }

  public render() {
    return (
      <>
        {
          this.state.processed !== undefined &&
          <Row>
            <h5 className="text-title">FIA status:</h5>
            <p className="text-content">{this.state.processed === false ? 'Error' : this.state.processed ? "Processed" : "Not processed yet"}</p>
          </Row>
        }
        {
          this.state.date !== undefined &&
          <Row>
            <h5 className="text-title">Processed at:</h5>
            <p className="text-content">{this.state.date} </p>
          </Row>
        }
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/Status.tsx